import type { TranslationKey } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import type { ProjectDataLoadingFailure } from 'store/project';
import { isNoProjectAccessFailureReason } from 'store/project';

/** What the main button of the failure screen does. */
export enum ProjectLoadingFailedAction {
  /** Waits again for the data still missing. */
  retry = 'retry',
  /** The worker is outdated: refreshes the page with the new one. */
  refresh = 'refresh',
  /** The user has no access to the project: opens the project list. */
  chooseProject = 'choose-project',
}

export function isChooseProjectAction(action: ProjectLoadingFailedAction): boolean {
  return action === ProjectLoadingFailedAction.chooseProject;
}

export type ProjectLoadingFailedContent = Readonly<{
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
  primaryAction: ProjectLoadingFailedAction;
}>;

/** The texts and the main action of the failure screen for the reason of the failure. */
export function getProjectLoadingFailedContent(failure: ProjectDataLoadingFailure): ProjectLoadingFailedContent {
  if (isNoProjectAccessFailureReason(failure.reason)) {
    return {
      titleKey: ProjectSetupTranslationKeys.loadingNoAccessTitle,
      descriptionKey: ProjectSetupTranslationKeys.loadingNoAccessDescription,
      primaryAction: ProjectLoadingFailedAction.chooseProject,
    };
  }
  if (failure.needsWorkerUpdate) {
    return {
      titleKey: ProjectSetupTranslationKeys.loadingFailedTitle,
      descriptionKey: ProjectSetupTranslationKeys.loadingFailedOutdated,
      primaryAction: ProjectLoadingFailedAction.refresh,
    };
  }
  return {
    titleKey: ProjectSetupTranslationKeys.loadingFailedTitle,
    descriptionKey: ProjectSetupTranslationKeys.loadingFailedDescription,
    primaryAction: ProjectLoadingFailedAction.retry,
  };
}
